import './index.less';
import Barrage from './Barrage';

Barrage.install = function(Vue) {
  Vue.component(Barrage.name, Barrage);
};

export default Barrage;
